<template>

  <b-card class="card-transaction" no-body  >
    <b-card-header>
      <b-card-title name="Estabelecimentos"> Estabelecimentos </b-card-title>
          <ModalEstabelecimento ></ModalEstabelecimento>
    </b-card-header>
    <b-card-body>
      <b-list-group>

      <b-list-group-item :disabled="isDisabled" @click="MudarEstabelecimento(index,item)" :class="{ 'active': item.active }"  v-for="item, index in lista_estabelecimentos" :key="index"  class="d-flex justify-content-between align-items-center">
      
      <span v-if="!item.spiner" >{{item.name}}  </span>
      <div v-if="item.spiner" > <b-spinner small  /> <span >Carregando...</span> </div>

      </b-list-group-item >
    
      </b-list-group>
    </b-card-body>

 
  </b-card>
</template>

<script>
import {
 BSpinner, BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem,BListGroup, BListGroupItem 
} from 'bootstrap-vue'

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ModalEstabelecimento from './ModalEstabelecimento.vue';

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BSpinner,
    ModalEstabelecimento,
},

  data() {
    return {
        status: "",
            password: "",
            show: false,
            isDisabled: false,
            spiner:false,

            estabelecimento: {
                name: null,
                cnpj: null,
                id: null,
                email: null,
                apiKey: null,
                responsible:null
            },
    };
  },


  created() {
    this.$store.dispatch("estabelecimentos/all_estabelecimentos");
  },
  computed: {
    lista_estabelecimentos() {
      console.log(this.$store.state.estabelecimentos.lista_estabelecimentos.data)
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
   
  },

   methods: {

  async  MudarEstabelecimento(index,dados) {
        this.isDisabled = true
        this.lista_estabelecimentos[index].spiner =  true

        

        this.$store.dispatch("estabelecimentos/saldoEstabelecimento", dados)
        // this.$store.dispatch("estabelecimentos/recebidosMes", dados)
        // this.$store.dispatch("estabelecimentos/recebidosHoje", dados)
        // this.$store.dispatch("estabelecimentos/pagamentosVencer", dados)

      await  this.BuscarEstabelecimentos(dados)

    // corrigir no futuro
      // await this.BuscarMovimentacoes(dados) 

      this.isDisabled = false
      this.lista_estabelecimentos[index].spiner =  false

      for (let lista in this.lista_estabelecimentos) {
        if(lista == index){
            this.lista_estabelecimentos[index].active =  true
        }else{
           this.lista_estabelecimentos[lista].active =  false
        }
      }

      this.$forceUpdate()
       
    },

   async BuscarMovimentacoes(dados){
    await this.$store.dispatch("estabelecimentos/getListMovimento", dados)
   },
   async BuscarEstabelecimentos(dados){
    

        await this.$store.dispatch("estabelecimentos/get_estabelecimento", dados)
        .then(() => {
            // console.log(this.$store.state.estabelecimentos.estabelecimento.allEstablishment)
           this.BuscarOrder( this.$store.state.estabelecimentos.estabelecimento.allEstablishment)
        
         })
        .catch((error) => {
         
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });

    },

    async BuscarOrder(dados){
      
        await this.$store.dispatch("estabelecimentos/getListOrder", dados)
        .then(() => { })
        .catch((error) => {
        
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });

    },

  async  SalvarEstabelecimento(){

    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
           this.$store.dispatch("estabelecimentos/all_estabelecimentos");
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
      this.isDisabled = false;
      this.show = true;
    },
  },
  
}
</script>
